/**
 * 配送方
 */

/** 库存类型 */
export const StockFlag = {
    /** 独立库存 * */
    INDEPENDENT: 0,
    /** 共享库存 * */
    SHARE: 1,
};

/** 送货方式 */
export const shippingTypeEnum = {
    /** 直送 */
    DTS: 10,
    /** 配送 */
    DC: 20,
    /** 送货方式为空 */
    NONE: 0,
    /** 领用 * */
    RECEIVE: 30,
    // 自加工
    SELF_PROCESS: 40,
    // 越库
    CROSS_DC: 50,
};

export const shippingTypeSearchEnum = {
    /** 直送 */
    DTS: 10,
    /** 配送 */
    DC: 20,
    /** 全部 */
    ALL: -1,
    /** 未设置 */
    NOSET: 0,
    // 自加工
    SELF_PROCESS: 40,
    // 越库
    CROSS_DC: 50,
    // 领用
    RECEIVE: 30,
};

export const shippingTypeOptions = [{
    label: '全部',
    value: -1,
},
{
    label: '直送',
    value: 10,
},
{
    label: '配送',
    value: 20,
},
{
    label: '领用',
    value: 30,
},
{
    label: '自加工',
    value: 40,
},
{
    label: '越库',
    value: 50,
},
{
    label: '未设置',
    value: 0,
},
];

export const shippingTypeCN2Val = {
    直送: 10,
    配送: 20,
    领用: 30,
    自加工: 40,
    越库: 50,
};

// 送货方式
export const shippingTypeEditOptions = [{
    label: '直送',
    value: 10,
},
{
    label: '配送',
    value: 20,
},
{
    label: '领用',
    value: 30,
},
{
    label: '自加工',
    value: 40,
},
{
    label: '越库',
    value: 50,
},
];
export const shippingTypeMap = {
    0: '全部',
    10: '直送',
    20: '配送',
    30: '领用',
    40: '自加工',
    50: '越库',
};

/**
 * 活动状态
 */
export const promotionStatusEnum = {
    /** 待生效 */
    INIT: 0,
    /** 已生效 */
    ONLINE: 10,
    /** 手动下线 */
    OFFLINE: 20,
    /** 已过期 */
    EXPIRED: 30,
};

export const promotionStatusMap = {
    /** 待生效 */
    0: '待生效',
    /** 已生效 */
    10: '生效中',
    /** 手动下线 */
    20: '手动下线',
    /** 已过期 */
    30: '已过期',
};
/**
 * 活动渠道
 * */
export const promotionChannelEnum = {
    /** 章鱼生鲜APP */
    APP: 1,
    /** 小程序 */
    APPLET: 2,
    /** 线下渠道 */
    OFFLINE: 3,
};


export const promotionChannelMap = {
    /** 小象生鲜APP */
    1: '小象生鲜APP',
    // /** 小程序 */  20200506 小程序状态拆分
    // 2: '小程序',
    /** 线下渠道 */
    3: '线下超市',
    4: '微信小程序',
    5: '美团小程序',
    6: '点评小程序',
};

export const unitEnum = {
    /** 克 */
    GRAM_UNIT_ID: 101,
    /** 千克 */
    KILOGRAM_UNIT_ID: 102,
    /** 毫升 */
    MILLILITRES_UNIT_ID: 111,
    /** 升 */
    LITRE_UNIT_ID: 112,
};
